import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { LayaGL } from "../layagl/LayaGL";
import { Color } from "../maths/Color";
import { Vector2 } from "../maths/Vector2";
import { Vector4 } from "../maths/Vector4";
import { RenderTexture2D } from "../resource/RenderTexture2D";
import { ColorUtils } from "../utils/ColorUtils";
import { ShaderDefines2D } from "../webgl/shader/d2/ShaderDefines2D";
import { TextureSV } from "../webgl/shader/d2/value/TextureSV";
import { Filter } from "./Filter";
export class GlowFilter extends Filter {
    constructor(color, blur = 4, offX = 6, offY = 6) {
        super();
        this._sv_blurInfo1 = new Array(4);
        this._sv_blurInfo2 = [0, 0, 1, 0];
        this._flipY = false;
        this._color = new ColorUtils(color || "#000");
        this.blur = Math.min(blur, 20);
        this.offX = offX;
        this.offY = offY;
        this._sv_blurInfo1[1] = this.blur;
        this.shaderDataBlur = new TextureSV();
        this.shaderDataBlur.u_blurInfo1 = new Vector4();
        this.shaderDataBlur.u_blurInfo2 = new Vector4();
        this.shaderDataBlur.color = new Vector4();
        this.shaderDataBlur.size = new Vector2();
        this.shaderDataBlur.blurInfo = new Vector2();
        this.shaderDataCopy = new TextureSV();
        this.shaderDataCopy.size = new Vector2();
        this.shaderDataCopy1 = new TextureSV();
    }
    _fillQuad(x, y, w, h, flipY = false) {
        let uvrect;
        if (flipY) {
            uvrect = [0, 1, 1, 0];
        }
        else {
            uvrect = [0, 0, 1, 1];
        }
        let rectVB = this._rectMeshVB;
        let stridef32 = this._rectMesh.vertexDeclarition.vertexStride / 4;
        rectVB[0] = x;
        rectVB[1] = y;
        rectVB[2] = uvrect[0];
        rectVB[3] = uvrect[1];
        rectVB[stridef32] = x + w;
        rectVB[stridef32 + 1] = y;
        rectVB[stridef32 + 2] = uvrect[2];
        rectVB[stridef32 + 3] = uvrect[1];
        rectVB[stridef32 * 2] = x + w;
        rectVB[stridef32 * 2 + 1] = y + h;
        rectVB[stridef32 * 2 + 2] = uvrect[2];
        rectVB[stridef32 * 2 + 3] = uvrect[3];
        rectVB[stridef32 * 3] = y;
        rectVB[stridef32 * 3 + 1] = y + h;
        rectVB[stridef32 * 3 + 2] = uvrect[0];
        rectVB[stridef32 * 3 + 3] = uvrect[3];
    }
    useFlipY(b) {
        super.useFlipY(b);
        this._flipY = b;
    }
    render(srctexture, width, height) {
        let marginLeft = 50;
        let marginTop = 50;
        this.left = -marginLeft;
        this.top = -marginTop;
        let outTexWidth = width + 2 * marginLeft;
        let outTexHeight = height + 2 * marginTop;
        this.width = outTexWidth;
        this.height = outTexHeight;
        if (!this.textureExtend || this.textureExtend.destroyed || this.textureExtend.width != outTexWidth ||
            this.textureExtend.height != outTexHeight) {
            if (this.textureExtend)
                this.textureExtend.destroy();
            this.textureExtend = new RenderTexture2D(outTexWidth, outTexHeight, RenderTargetFormat.R8G8B8A8);
            this.textureExtend._invertY = LayaGL.renderEngine._screenInvertY;
        }
        let render2d = this._render2D.clone(this.textureExtend);
        render2d.renderStart(true, new Color(0, 0, 0, 0));
        this.shaderDataCopy1.size = new Vector2(outTexWidth, outTexHeight);
        this.shaderDataCopy1.textureHost = srctexture;
        this._fillQuad(marginLeft, marginTop, srctexture.width, srctexture.height, this._flipY);
        render2d.draw(this._rectMesh, 0, 4 * this._rectMesh.vertexDeclarition.vertexStride, 0, 12, this.shaderDataCopy1, null);
        render2d.renderEnd();
        if (!this.texture || this.texture.destroyed || this.texture.width != outTexWidth || this.texture.height != outTexHeight) {
            if (this.texture)
                this.texture.destroy();
            this.texture = new RenderTexture2D(outTexWidth, outTexHeight, RenderTargetFormat.R8G8B8A8);
        }
        render2d = render2d.clone(this.texture);
        render2d.renderStart(true, new Color(0, 0, 0, 0));
        this._fillQuad(0, 0, outTexWidth, outTexHeight, true);
        let shadersv = this.shaderDataBlur;
        shadersv.shaderData.addDefine(ShaderDefines2D.FILTERGLOW);
        let size = shadersv.size;
        size.setValue(outTexWidth, outTexHeight);
        shadersv.size = size;
        shadersv.textureHost = this.textureExtend;
        let blurInfo = shadersv.blurInfo;
        blurInfo.setValue(outTexWidth, outTexHeight);
        shadersv.blurInfo = blurInfo;
        let u_blurInfo1 = shadersv.u_blurInfo1;
        u_blurInfo1.setValue(this._sv_blurInfo1[0], this._sv_blurInfo1[1], this._sv_blurInfo1[2], this._sv_blurInfo1[3]);
        shadersv.u_blurInfo1 = u_blurInfo1;
        let u_blurInfo2 = shadersv.u_blurInfo2;
        u_blurInfo2.setValue(srctexture.width, srctexture.height, this._sv_blurInfo2[2], this._sv_blurInfo2[3]);
        shadersv.u_blurInfo2 = u_blurInfo2;
        let color = this._color.arrColor;
        let svColor = shadersv.color;
        svColor.setValue(color[0], color[1], color[2], color[3]);
        shadersv.color = svColor;
        render2d.draw(this._rectMesh, 0, 4 * this._rectMesh.vertexDeclarition.vertexStride, 0, 12, shadersv, null);
        let shadercpy = this.shaderDataCopy;
        size = shadercpy.size;
        size.setValue(outTexWidth, outTexHeight);
        shadercpy.size = size;
        shadercpy.textureHost = srctexture;
        this._fillQuad(marginLeft, marginTop, srctexture.width, srctexture.height, this._flipY);
        render2d.draw(this._rectMesh, 0, 4 * this._rectMesh.vertexDeclarition.vertexStride, 0, 12, shadercpy, null);
        render2d.renderEnd();
    }
    get typeDefine() {
        return ShaderDefines2D.FILTERGLOW;
    }
    get offY() {
        return this._sv_blurInfo1[3];
    }
    set offY(value) {
        this._sv_blurInfo1[3] = value;
        this.onChange();
    }
    get offX() {
        return this._sv_blurInfo1[2];
    }
    set offX(value) {
        this._sv_blurInfo1[2] = value;
        this.onChange();
    }
    get color() {
        return this._color.strColor;
    }
    set color(value) {
        this._color = new ColorUtils(value);
        this.onChange();
    }
    get blur() {
        return this._sv_blurInfo1[1];
    }
    set blur(value) {
        this._sv_blurInfo1[0] = this._sv_blurInfo1[1] = value;
        this.onChange();
    }
}
